export enum AttributeType {
	PartProperty = 10,
    OrderItemTag = 20
}